import * as XLSX from 'xlsx';
import Papa from 'papaparse';
export function capitalizeFirstLetter(text) {
    if (!text) return ''; // Maneja el caso de cadena vacía
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  }

  export function capitalizerTitle(text) {
    // Lista de palabras conectores que no deben capitalizarse
    const connectors = ["de", "la", "en", "los", "las", "del", "y", "o", "a", "por", "para", "con", "al"];
    
    // Divide el texto en palabras y procesa cada una
    return text
      .toLowerCase() // Asegura que todo esté en minúsculas antes de procesar
      .split(" ") // Divide en palabras
      .map((word, index) => {
        // Capitaliza si no está en la lista de conectores o si es la primera palabra
        if (!connectors.includes(word) || index === 0) {
          return word.charAt(0).toUpperCase() + word.slice(1);
        }
        return word; // Devuelve la palabra sin cambios si es un conector
      })
      .join(" "); // Une las palabras en una cadena nuevamente
  }
  
export function importFunction(file,setFileContent,setTableData){
   
  const reader = new FileReader();

  reader.onload = (event) => {
    const fileData = event.target.result;
    if (file.type === "application/json") {
      // Parse JSON
      const jsonData = JSON.parse(fileData);
      const keys = Object.keys(jsonData[0]);
      const values = jsonData.map(obj => Object.values(obj));
      const result = [keys, ...values];
      setFileContent(result);
      setTableData(result); // Puedes ajustar esto según la estructura del archivo JSON
    } else if (file.type === "application/vnd.ms-excel" || file.type === "text/csv" ) {
      // Procesar CSV (convertir a una tabla)
      // const csvData = fileData.split('\n').map(row => row.split(','));
      // console.log(csvData)
      // setFileContent(csvData);
      // setTableData(csvData);
      const reader = new FileReader();
      reader.onload = ({ target }) => {
        const csvData = Papa.parse(target.result, {
            delimiter: ",",   // Usa coma como separador
            quoteChar: '"',   // Mantiene los valores entre comillas
            header: false,    // Si no tiene encabezado, usa false
            skipEmptyLines: true,
        });
        setFileContent(csvData.data);
        setTableData(csvData.data);
      };
      reader.readAsText(file);
    }else if (file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
      // Procesar archivo Excel (.xlsx)
      const workbook = XLSX.read(new Uint8Array(fileData), { type: 'array' });
      const sheetName = workbook.SheetNames[0]; 
      const worksheet = workbook.Sheets[sheetName];
      const excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }); 

      setFileContent(excelData);
      setTableData(excelData);
    }   else {
      console.error("Formato de archivo no soportado");
    }
  };
  if (file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
    reader.readAsArrayBuffer(file);
  } else {
    reader.readAsText(file);
  }
 }


 export function formatValue(value) {
  const num = parseFloat(value); // Convertir el valor a número
  if (Number.isInteger(num)) {
      return num; // Si es un entero, devolverlo como está
  }
  
  const decimals = num.toString().split(".")[1]?.length || 0; // Contar los decimales
  
  if (decimals === 0) {
      return Math.trunc(num); // Si los decimales son 0, devolver como entero
  } else if (decimals > 3) {
      return parseFloat(num.toFixed(3)); // Si tiene más de 3 decimales, fijar a 3
  } else {
      return num; // Si tiene menos de 3 decimales, devolver tal cual
  }
}

export function TimeFormatter( seconds ) {
 
    if(seconds==null){return ''}
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    const parts = [];
    if (hours > 0) parts.push(`${hours}h`);
    if (minutes > 0) parts.push(`${minutes}m`);
    if (secs > 0 || parts.length === 0) parts.push(`${secs}s`);

    return parts.join(' ');


  
}

// utils/exportToCsv.js
export function exportToCsv(filename, rows,setExportLoading) {
  setExportLoading(true);
  if (!rows || !rows.length) {
    setExportLoading(false);
    console.error("No hay datos para exportar");
    return;
  }

  // Extraer cabeceras
  const headers = Object.keys(rows[0]);

  // Crear el contenido CSV
  const csvContent = [
    headers.join(","), // encabezados
    ...rows.map(row =>
      headers.map(header => JSON.stringify(row[header] ?? "")).join(",")
    ),
  ].join("\n");

  // Crear un blob y enlace de descarga
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);

  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setExportLoading(false);
}


export function getCurrentDate(separator = "-") {
  const today = new Date();
  const day = String(today.getDate()).padStart(2, "0");
  const month = String(today.getMonth() + 1).padStart(2, "0"); // enero = 0
  const year = today.getFullYear();

  return `${year}${separator}${month}${separator}${day}`;
}